(() => {
  const root = document.getElementById('form-living-library');
  if (!root) return;
  const details = root.querySelector('details');
  const cards = [...root.querySelectorAll('[data-rfl-category]')];
  const buttons = [...root.querySelectorAll('[data-rfl-filter]')];
  const search = root.querySelector('#rfl-search');
  const status = root.querySelector('.rfl-status');
  let category = 'all';
  const update = () => {
    const term = search.value.trim().toLocaleLowerCase();
    let count = 0;
    cards.forEach(card => {
      const visible = (category === 'all' || card.dataset.rflCategory === category) && (!term || card.textContent.toLocaleLowerCase().includes(term));
      card.hidden = !visible;
      if (visible) count++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.rflFilter === category)));
    status.textContent = count + ' ' + status.dataset.countLabel;
    root.querySelector('.rfl-empty').hidden = count !== 0;
  };
  buttons.forEach(button => button.addEventListener('click', () => {category = button.dataset.rflFilter; update();}));
  search.addEventListener('input',update);
  root.querySelector('[data-rfl-reset]').addEventListener('click', () => {category='all'; search.value=''; update();});
  const reveal = () => {if (location.hash === '#form-living-library') details.open = true;};
  document.querySelectorAll('a[href="#form-living-library"]').forEach(link => link.addEventListener('click', () => {details.open=true;}));
  window.addEventListener('hashchange',reveal);
  root.querySelector('.rfl-tools').hidden = false;
  update(); reveal();
})();
